
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionRelativeProposal as ObiMotionRelativeProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-relative-proposal.js';
 
 
 

 
 export const ObiMotionRelativeProposal = createComponent({
   react: React,
   tagName: 'obi-motion-relative-proposal',
   elementClass: ObiMotionRelativeProposalElement,
   events: {
     
   }
  });
 
 